/* eslint-disable */
export function sting(): string {
    return 'sting';
}
